import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { SubmitHandler, FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useValidation, useTranslation } from 'hooks';
import { translations } from './translations';

import * as S from './styles';

import { Modal } from 'components/shared';
import { Select, Input } from 'components/shared/Form';
import { ListModulesActions, ListModulesState } from 'store/ducks/modules';

interface IFilterProps {
  onFilter: Function;
}

export const FilterPermissions: React.FC<IFilterProps> = ({ onFilter }) => {
  const dispatch = useDispatch();
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors } = useValidation();
  const { getTranslation } = useTranslation(translations);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [cleanShow, setCleanShow] = useState<boolean>(false);

  const { loading: loadingModules, data: dataModules } = useSelector<
    RootStateOrAny,
    ListModulesState
  >((state: any) => state.listModules);

  const getListModules = useCallback(() => {
    dispatch(
      ListModulesActions.request({
        all: true,
      })
    );
  }, [dispatch]);

  useEffect(() => getListModules(), [getListModules]);

  const handleSubmit = useCallback<SubmitHandler>(
    async (data: any) => {
      try {
        onFilter(data);

        setCleanShow(true);
        setModalOpen(false);
      } catch (error) {
        handleFormErrors(error, formRef);
      }
    },
    [handleFormErrors, onFilter]
  );

  const handleFilterClean = useCallback(() => {
    if (formRef.current) {
      formRef.current.setFieldValue('search', '');
      formRef.current.setFieldValue('general_module_id', '');
      formRef.current.setFieldValue('domain', '');
      const clean = {
        search: '',
        general_module_id: '',
        domain: '',
      };
      onFilter(clean);
    }

    setCleanShow(false);
    setModalOpen(false);
  }, [onFilter]);

  const renderButtonCleanFilter = () => {
    if (cleanShow) {
      return (
        <S.ButtonMini btStyle="dark" onClick={handleFilterClean}>
          {getTranslation('limparFiltro')}
        </S.ButtonMini>
      );
    }
  };

  return (
    <S.Container>
      <Modal isOpen={modalOpen}>
        <S.ModalContainer>
          <S.Header>
            <S.IconFilter />
            <S.Title>{getTranslation('filtrar')}</S.Title>
          </S.Header>
          <Form
            ref={formRef}
            onSubmit={handleSubmit}
            placeholder=""
            onPointerEnterCapture={() => {}}
            onPointerLeaveCapture={() => {}}
          >
            <S.FormRow>
              <Input name="search" label={getTranslation('nome')} />
              <Input name="domain" label={getTranslation('grupo')} />
            </S.FormRow>

            <S.FormRow>
              <Select
                name="general_module_id"
                label="Módulo"
                isLoading={loadingModules}
                isDisabled={loadingModules}
                options={dataModules}
              />
            </S.FormRow>
            <S.ButtonsWrapper>
              <S.Button
                btStyle="cancel"
                onClick={() => setModalOpen(false)}
                type="button"
              >
                {getTranslation('cancelar')}
              </S.Button>
              <S.Button
                btStyle="danger"
                type="button"
                onClick={handleFilterClean}
              >
                {getTranslation('limparFiltro')}
              </S.Button>
              <S.Button type="submit">{getTranslation('filtrar')}</S.Button>
            </S.ButtonsWrapper>
          </Form>
        </S.ModalContainer>
      </Modal>

      {renderButtonCleanFilter()}
      <S.ButtonFilter onClick={() => setModalOpen(true)}>
        <S.IconFilter />
      </S.ButtonFilter>
    </S.Container>
  );
};
